export default __webpack_public_path__ + "maps-examples-image-source-960-3d7ffd4cc7606222e035475814204b2c.png";